<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="BtnExtra">
                <button @click="IrAOpciones" type="button" class="btn btn-sm btn-primary">
                    <i class="fas fa-list"></i> Opciones Encuesta
                </button>
            </template>
            <!-- <template slot="AntTabla">
                <div class="row mt-3 mb-3">
                    <div class="col-sm-12 col-lg-6 text-center">
                        <h4>Encuesta Para Coordinadores</h4>
                        <button class="btn btn-primary">
                            <i class="fas fa-plus-circle"></i> ESPAÑOL
                        </button>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                        <h4 class="text-center">Encuesta Para Parejas</h4>
                        <div class="row">
                            <div class="col-sm-12 col-lg-6 text-center">
                                <button class="text-center btn btn-primary">
                                    <i class="fas fa-plus-circle"></i> ESPAÑOL
                                </button>
                            </div>
                            <div class="col-sm-12 col-lg-6 text-center">
                                <button class="text-center btn btn-primary">
                                    <i class="fas fa-plus-circle"></i> INGLES
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template> -->
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Tipo de Encuesta</th>
                <th :class="StyleTh">Idioma</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh">Año</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(item,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{item.TipoEncuesta}}</h6></td>
                    <td><p :class="StyleTd">{{item.Idioma}}</p></td>
                    <td><p :class="StyleTd">{{item.Estatus}}</p></td>
                    <td><p :class="StyleTd">{{item.Anio}}</p></td>
                    <td>
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="item.IdConfigEncuesta" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <!-- Remover v-show en caso de agregar más botones -->
                                <CMoreButtonsL v-show="segurity.ViewSection">
                                    <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewSection">
                                            <li @click="IrAPreguntas(item.IdConfigEncuesta)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-list"></i> Ver Preguntas
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :pListaEncuesta="ListaArrayRows"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
import Form from '@/views/modulos/crm/encuesta/Form.vue';
const EmitEjecuta = 'seccionEncuesta';
export default {
    name: 'ListaEncuesta',
    props: ['sFiltros','pOrigen'],
    components:{Form},
    data() {
        return {
            ConfigList:{
                Title: 'Encuestas',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'CRM',
                GoRoute: 'preguntas',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'xl'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                ShowSpinner:false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Anio:''
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            this.$http.get("configEncuestas",{
                params:{
                    Anio:this.Anio
                }
            }).then((res)=>{
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('configEncuestas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus'})
        },
        IrAOpciones(){
            this.$router.push({name:'opcionencuesta'})
        },
        IrAPreguntas(Id){
            this.$router.push({name:'preguntas',params:{'IdConfigEncuesta':Id}});
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>

<style>

</style>